
import React, { Fragment, useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import { toISTDate } from '@Apis/constants';
import CategoryFilterNew from '../../../../Common/CategoryFilterNew';
import H3FormInput from '@Uilib/h3FormInput';
import ProductActions from '@Actions/productActions';
import {
  Button,
  Select, Spin, Table, Tooltip,
} from 'antd';
const { Option } = Select;
import './style.scss';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const FilterProducts = ({
  user,  getProducts, getOrgUsers, tenantId, products,
   getProductsLoading, onSubmit, callback, selectedProducts,
}) => {
  const [selectedType, setSelectedType] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [productName, setProductName] = useState('');
  const [page, setPage] = useState(1);
  const [barcode, setBarcode] = useState('');
  const [selectedRowKeys, setSelectedRowKeys] = useState(null);
  const [selectedRows, setSelectedRows] = useState(null);
  const [call, setCall] = useState(null);
  const [otherFilters, setOtherFilters] = useState([]);

  const getColumns = () => {
    const columns = [
      {
        title: 'SKU#',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <Link to={`/inventory/product/view/${record?.product_info?.product_sku_id}?tab=/general-information`}>
            {`#${record?.product_info?.internal_sku_code}`}
          </Link>
        ),
        fixed: 'left',
      },
      {
        title: 'Product',
        width: '250px',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (
          <div style={{ maxWidth: '500px' }}>
            <div className="prod-table__text">
              {`${record?.product_info?.ref_product_code ? `${record?.product_info?.ref_product_code} - ` : ''}${record?.product_info?.product_sku_name}`}
            </div>
            {(record.product_type !== 'STORABLE' && record.product_type) && (
              <div className="inventory-qr__status" style={{ backgroundColor: Helpers.getProductType(record.product_type)?.color }}>{Helpers.getProductType(record.product_type)?.text}</div>
            )}
            {record?.product_category_info?.category_path && (
              <Tooltip
                overlay={(
                  <div
                    style={{
                      color: 'rgb(0, 0, 0)',
                      fontSize: '12px',
                      fontWeight: '500',
                      padding: '2px',
                    }}
                  >
                    {record.product_category_info.category_path.join(' / ')}
                  </div>
                )}
                color="rgb(234, 242, 254)"
              >
                <div
                  className="inventory-qr__status"
                  style={{ backgroundColor: '#3aa5a6' }}
                >
                  {record?.product_category_info ? (
                    `.../${record?.product_category_info?.product_category_name}`
                  ) : (
                    ''
                  )}
                </div>
              </Tooltip>
            )}
            {(user?.tenant_info?.global_config?.settings?.marketplace_enabled && record.is_marketplace_product) && (
              <div className="inventory-qr__status" style={{ backgroundColor: '#f58428' }}>
                Marketplace
              </div>
            )}
          </div>
        ),
      },
      {
        title: 'Unit',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => record?.uom_info?.uqc,
      },
      {
        title: 'Sale',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (record?.is_sales_product ? <div className="product-list__sales-status-yes" /> : <div className="product-list__sales-status-no" />),
      },
      {
        title: 'Purchase',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        render: (text, record) => (record?.is_purchase_product ? <div className="product-list__sales-status-yes" /> : <div className="product-list__sales-status-no" />),
      },
    ];
    return columns;
  };

  
  useEffect(() => {
    getProducts(
      productName, // search keyword
      tenantId, //tenant ids
      null, // stock status
      100, // limit
      page, // page
      null, // tenantDepartmentId
      null, // exclude out of stock
      selectedType?.join(','), // selected type
      selectedCategory?.join(','), // category
      otherFilters?.includes('SALES_ENABLED') ? true : null, // isSalesProduct
      otherFilters?.includes('PURCHASE_ENABLED') ? true : null, // isPurchaseProduct
      null, //search,
      null, // sort by
      null, //filterReservedQuantity,
      barcode, // barcode
      otherFilters?.includes('SHOPIFY') ? true : null, //isShopifyProduct,
      otherFilters?.includes('MARKETPLACE') ? true : null, //isMarketplaceProduct
      )
  }, [call])

  const getDataSource = (data) => {
    return data?.map((item) => ({ ...item, key: item?.product_sku_id })); // Map to add key property
  };

  const productTypeOptions = [
    { label: 'Storable', value: 'STORABLE' },
    { label: 'Non Storable', value: 'NON_STORABLE' },
    { label: 'Bundle', value: 'BUNDLE' },
    { label: 'Service', value: 'SERVICE' },
  ];

  const productSourceOptions = [
    { label: 'Sales Enabled', value: 'SALES_ENABLED' },
    { label: 'Purchase Enabled', value: 'PURCHASE_ENABLED' },
    { label: 'Marketplace', value: 'MARKETPLACE' },
    { label: 'Imported from Shopify', value: 'SHOPIFY' },
  ];

  return (
    <Spin spinning={getProductsLoading === true}>
      <div className="">
        <div className="product-filters__wrapper" style={{ paddingTop: '70px' }}>
          <div className="ant-row">
            <div className="ant-col-md-8">
              <div className="orgInputContainer">
                <label className="orgFormLabel">
                  Product Type
                </label>
                <PRZSelect
                  value={selectedType}
                  onChange={(value) => {
                    setSelectedType(value);
                    setCurrentPage(1);
                  }}
                  placeholder="Product Type"
                  mode="multiple"
                  maxTagCount="responsive"
                  options={productTypeOptions}
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer">
                <label className="orgFormLabel">
                  Product Category
                </label>
                <CategoryFilterNew
                  selectedCategory={selectedCategory}
                  containerClassName="orgInputContainer"
                  hideTitle
                  placeholder="Product Category"
                  style={{
                    width: '100%',
                    borderRadius: '2px',
                    border: '1px solid lightgrey'
                  }}
                  onChange={(value, title) => {
                    setSelectedCategory(value);
                  }}
                  allowClear
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer">
                <label className="orgFormLabel">
                  Search by Name
                </label>
                <H3FormInput
                  name="Product Group Name"
                  type="text"
                  containerClassName="create-price-list__input-row__input"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput input"
                  placeholder="eg. Unicommerce sync list"
                  onChange={(e) => setProductName(e.target.value)}
                  value={productName}
                  required
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer">
                <label className="orgFormLabel">
                  Barcode
                </label>
                <H3FormInput
                  name="Product Group Name"
                  type="text"
                  containerClassName="create-price-list__input-row__input"
                  inputClassName="orgFormInput input"
                  placeholder="eg. 536727362"
                  onChange={(e) => setBarcode(e.target.value)}
                  value={barcode}
                  required
                />
              </div>
            </div>
            <div className="ant-col-md-8">
              <div className="orgInputContainer">
                <label className="orgFormLabel">
                  Other Filters
                </label>
                <PRZSelect
                  value={otherFilters}
                  onChange={(value) => {
                    setOtherFilters(value);
                  }}
                  mode="multiple"
                  maxTagCount="responsive"
                  options={productSourceOptions}
                />
              </div>
            </div>
          </div>
        </div>
        <Button
          type="primary"
          ghost
          onClick={() => {
            setCall(!call);
          }}
        >
          Search
        </Button>

        <div className="product-filter-table" style={{ marginTop: '10px' }}>
          <Table
            title={() => (
              <div className="product-filter-table__title">
                <H3Text text={`${products?.count || 0} Products`} className="" />
              </div>
            )}
            bordered
            showHeader
            size="small"
            columns={getColumns()}
            dataSource={getDataSource(products?.result?.products) || []}
            scroll={{ y: 'calc(100dvh - 420px)' }}// Set a fixed height for the table
            pagination={{
              current: page,
              pageSize: 100,
              total: products?.count ?? 0,
              position: ['bottomLeft'],
              showSizeChanger: false,
              showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
              onChange: (pg) => {
                setPage(pg);
                setCall(!call);
              },
            }}
            rowSelection={(window.screen.width > 425) ? {
              onChange: (rowKeys, rows) => {
                setSelectedRowKeys(rowKeys);
                setSelectedRows(rows);
              },
              selectedRowKeys,
              getCheckboxProps: (record) => ({
                disabled: selectedProducts?.find((i) => i.product_sku_id == record.product_sku_id),
              }),
            } : false}
          />
        </div>
      </div>
      <div className="custom-drawer__footer" style={{ width: '100%' }}>
          <Button
              type="primary"
              onClick={() => {
                onSubmit(selectedRowKeys?.map((item) => {
                  const product = products?.result?.products?.find((i) => i?.product_sku_id == item);
                  return {
                    key: product?.product_sku_id,
                    product_sku_id: product?.product_sku_id,
                    product_sku_info: product?.product_info,
                  }
                }));
                setSelectedRowKeys(null);
                setSelectedRows(null);
              }}
            >
            Add Products
          </Button>
      </div>
    </Spin>
  );
};
const mapStateToProps = ({
  UserReducers, ProductReducers, 
}) => ({
  user: UserReducers.user,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FilterProducts));
